/* hs-eslint ignored failing-rules */
/* eslint-disable no-bitwise */
import { getHistory } from '../routing/history';
export const createFreshUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let v;
    const r = Math.random() * 16 | 0;
    if (c === 'x') {
      v = r;
    } else {
      v = r & 0x3 | 0x8;
    }
    return v.toString(16);
  });
};
export const addIdToUrl = id => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  searchParams.set('uuid', id);
  getHistory().replace(`${getHistory().location.pathname}?${searchParams}`);
};
export const createUuid = () => {
  const searchParams = new URLSearchParams(getHistory().location.search);
  const uuidFromQueryParam = searchParams.get('uuid');
  const shouldUseQueryParam = uuidFromQueryParam && uuidFromQueryParam.length <= 64;
  const uuid = shouldUseQueryParam && uuidFromQueryParam || createFreshUuid();
  if (searchParams.get('uuid') !== uuid) {
    addIdToUrl(uuid);
  }
  return uuid;
};